<script>
import formatDate from '@utils/format-date'
import setWindowHistory, { getUrlParameter } from "@utils/window-history";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";
import formatOrderPrepaid from "@utils/format-order-prepaid";

const DEFAULT_FILTER = {
  type: '',
  date: formatDate(new Date(), 'yyyy-MM'),
  order_by: 'created_at',
  order: 'desc',
};

export default {
  components: {
    SectionList: () => import("./DepositListHistoryList.Jtails.vue"),
  },
  data() {
    return {
      filter: {
        type: getUrlParameter('filterType') || DEFAULT_FILTER.type,
        date: getUrlParameter('filterDate') || DEFAULT_FILTER.date,
        order_by: DEFAULT_FILTER.order_by,
        order: DEFAULT_FILTER.order,
      },
      orderList: [],
      orederPagination: {},
    }
  },
  created() {
    this.tryToFetchDepositHistory();
  },
  methods: {
    formatOrderPrepaid,
    formatTextUpperCasefirst,
    onChangePagination(page) {
      this.tryToFetchDepositHistory({
        storeParams: {
          ...this.$route.params,
          page
        }
      })
    },
    onChangeFilter(name, value) {
      setWindowHistory({
        query: {
          ...this.$route.query,
          [name]: value || undefined
        }
      });

      this.tryToFetchDepositHistory({
        storeParams: {
          ...this.$route.query,
          [name]: value
        }
      });
    },
    clearFilter() {
      Object.keys(this.filter)
        .forEach(key => {
          this.filter[key] = DEFAULT_FILTER[key];

          setWindowHistory({
            query: {
              ...this.$route.query,
              [`filter${this.formatTextUpperCasefirst(key)}`]: DEFAULT_FILTER[key] || undefined,
              // page: 1
            }
          });
        });

      this.tryToFetchDepositHistory({
        storeParams: {
          page: 1
        }
      });
    },
    tryToFetchDepositHistory({ storeParams } = {}) {
      this.$store.dispatch('order/fetchDepositHistory', {
        // page: this.$route.query.page,
        type: this.filter.type,
        date: this.filter.date,
        order_by: this.filter.order_by,
        order: this.filter.order,
        ...storeParams
      })
        .then((response) => {
          this.orderList = response.items;
          this.orederPagination = response.pagination;
        });
    },
  }
}
</script>
<!-- section template -->
<template>
  <div>
    <div class="text-right mb-4">
      <el-date-picker 
        v-model="filter.date"
        class="isStyleFilter mr-4"
        type="month"
        value-format="yyyy-MM"
        :class="$globalIsDingBeauty ? 'isStyleDingBeauty isUnderLine' : ''"
        :popper-class="$globalIsDingBeauty ? 'isStyleSquare' : ''"
        placeholder="請選擇月份"
        @change="onChangeFilter('filterDate', $event)">
      </el-date-picker>
      <el-select
        v-model="filter.type"
        class="isStyleFilter"
        :class="$globalIsDingBeauty ? 'isStyleDingBeauty isUnderLine' : ''"
        placeholder="選擇狀態"
        @change="onChangeFilter('filterType', $event)"
      >
        <el-option label="所有狀態" value=""></el-option>
        <el-option label="儲值" value="charge"></el-option>
        <el-option label="使用" value="paid"></el-option>
        <el-option label="退款" value="refund"></el-option>
        <el-option label="結清轉現" value="withdraw"></el-option>
      </el-select>
    </div>
    <template v-if="$isLoading('fetchDepositHistory') || !!orderList[0]"> 
      <SectionList
        :order-list="orderList"
        :pagination="orederPagination"
      />
      <BasePagination
        :pagination="orederPagination"
        class="viewMemberPrepaidList__pagination"
        @change="onChangePagination"
      />
    </template>
    <template
      v-else-if="!filter.date && !filter.type && orederPagination.current_page <= orederPagination.last_page"
    >
      <BaseNull
        :image="`${ require(`@assets/images/${$globalProjectName}/reservation/no-service.svg`) }`"
        title="尚無任何使用紀錄"
      >
        <BaseButton
          class=" mt-5 isCol4 isOutline3"
          :class="{ 'isRadius isStylePrimary': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
          :to="{ name: 'deposit' }"
        >
          <span>立即購買</span>
        </BaseButton>
      </BaseNull>
    </template>
    <template v-else>
      <BaseNull
        :image="`${ require(`@assets/images/${$globalProjectName}/reservation/no-service.svg`) }`"
        title="沒有符合搜尋條件的使用紀錄"
      >
        <BaseButton
          class=" mt-5 isCol4 isOutline3"
          :class="{ 'isRadius isStylePrimary': $globalIsJtails, 'isStyleSecondary': $globalIsDingBeauty }"
          @click="clearFilter"
        >
          <span>清除條件</span>
        </BaseButton>
      </BaseNull>
    </template>
  </div>
</template>

<!-- section style -->
<style lang="scss" module>
.viewMemberPrepaidList {
  :global {
    .viewMemberPrepaidList {
      &__pagination {
        position: sticky;
        bottom: 0;
        padding-top: 1rem;
        padding-bottom: 2rem;
        margin-top: -1rem;
        margin-bottom: -2rem;
        background: #FFF;
      }
    }
  }
}
</style>





